import { render, staticRenderFns } from "./article_story_foot.vue?vue&type=template&id=00dd1a7d&lang=pug"
import script from "./article_story_foot.vue?vue&type=script&lang=js"
export * from "./article_story_foot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports